export default __webpack_public_path__ + "assets/images/abe0124012a062257763862465fbae61.png";